import workerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url';

const getPDFLib = async () => {
    const pdfjs = await import('pdfjs-dist/build/pdf.mjs');

    pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

    return pdfjs;
};
export { getPDFLib };
